import React, { useCallback } from 'react'
import useLocalStorage from '../../hooks/useLocalStorage'
import _ from 'lodash'

export const RecentlyViewedContext = React.createContext<{
  value: number[]
  setValue(val: number[]): void
  addId(id: number): void
}>({ value: [], setValue: () => null, addId: () => null })

export const RECENTLY_VIEWED_PRODUCTS_STORAGE_KEY = 'recentlyViewed'

export const RecentlyViewedProvider: React.FC = ({ children }) => {
  const [storedValue, setValue] = useLocalStorage<number[]>(RECENTLY_VIEWED_PRODUCTS_STORAGE_KEY, [])
  const addId = useCallback(
    (id: number) => {
      setValue(prev => _.uniq([id, ...prev.filter(id_ => id_ !== id)]).slice(0, 20))
    },
    [storedValue]
  )
  return (
    <RecentlyViewedContext.Provider value={{ value: storedValue, setValue, addId }}>
      {children}
    </RecentlyViewedContext.Provider>
  )
}
